import { create } from 'zustand';
import type { LoginResponse, UserInfo } from '@/api/types';

type Status = 'unknown' | 'authenticated' | 'anonymous';

interface AuthState {
  /** Kept in memory only (never localStorage). The refresh token lives in an HttpOnly cookie. */
  accessToken: string | null;
  user: UserInfo | null;
  status: Status;
  setSession: (response: LoginResponse) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  status: 'unknown',
  setSession: (response) => set({ accessToken: response.accessToken, user: response.user, status: 'authenticated' }),
  clear: () => set({ accessToken: null, user: null, status: 'anonymous' }),
}));

const LAST_TENANT_KEY = 'aml.lastTenant';

export const lastTenant = {
  get: (): string => {
    try {
      return localStorage.getItem(LAST_TENANT_KEY) ?? '';
    } catch {
      return '';
    }
  },
  set: (slug: string) => {
    try {
      localStorage.setItem(LAST_TENANT_KEY, slug);
    } catch {
      /* storage unavailable */
    }
  },
};
